export const featurePageMapping: { [key: string]: PageMapping } = {
	"/count": {
		actions: [],
		buttons: [],
		icon: "qr_code_scanner",
		label: "Count",
		labelKey: "nav.count.module.label",
		nav: false,
		title: ""
	},
	"/count/lines": {
		actions: [],
		buttons: [],
		icon: "view_list",
		label: "Lines",
		labelKey: "nav.count.lines.label",
		nav: true,
		title: "Count Lines",
		titleKey: "nav.count.lines.title"
	},
	"/count/sessions": {
		actions: [],
		buttons: [],
		icon: "playlist_play",
		label: "Sessions",
		labelKey: "nav.count.sessions.label",
		nav: true,
		title: "Count Sessions",
		titleKey: "nav.count.sessions.title"
	},
	"/count/devices": {
		actions: [],
		buttons: [],
		icon: "devices",
		label: "Devices",
		labelKey: "nav.count.devices.label",
		nav: true,
		title: "Count Devices",
		titleKey: "nav.count.devices.title"
	},
	"/count/admin/settings": {
		actions: [],
		buttons: [],
		icon: "settings",
		label: "Settings",
		labelKey: "nav.count.settings.label",
		nav: true,
		title: "Count Settings",
		titleKey: "nav.count.settings.title"
	}
};

export const flatPageMapping: { [key: string]: PageMapping } = {
	...featurePageMapping,
	"/count/lines/.+": {
		actions: [],
		buttons: [],
		identifier: true,
		label: "Line",
		labelKey: "nav.count.line.label",
		nav: false,
		title: ""
	},
	"/count/sessions/.+/live": {
		actions: [],
		buttons: [],
		identifier: true,
		label: "Live Session",
		labelKey: "nav.count.liveSession.label",
		nav: false,
		title: ""
	}
};
